/**
 * Navigation: Menü-Toggle, Header ein-/ausblenden beim Scrollen, Zustand „ganz oben“
 * (transparenter Header) vs. ab mindestens 50vh Scroll (Hintergrund via CSS an .nav-down).
 */
export function navigation() {
	const header = document.querySelector('.site__header')
	const navMenu = document.querySelector('.nav__menu')

	if (!header || !navMenu) {
		return
	}

	/** Mindest-Offset in px (50% der Viewport-Höhe), ab dem „nicht mehr ganz oben“ / Hide-Logik greift */
	function scrollThresholdPx() {
		return Math.max(0, window.innerHeight * 0.5)
	}

	function getScrollTop() {
		return window.pageYOffset !== undefined
			? window.pageYOffset
			: (document.documentElement || document.body.parentNode || document.body).scrollTop
	}

	/** true, solange die Seite noch im oberen Bereich (unterhalb des Schwellwerts) ist */
	function updateHeaderTopState(scrollTop) {
		const atTop = scrollTop < scrollThresholdPx()
		header.classList.toggle('site__header--at-top', atTop)
		return atTop
	}

	function toggleMenu() {
		const body = document.querySelector('body')

		if (body.classList.contains('js-nav-open')) {
			body.classList.remove('js-nav-open')
			navMenu.classList.remove('is-active')
		} else {
			body.classList.add('js-nav-open')
			navMenu.classList.add('is-active')
		}
	}

	document.querySelectorAll('.js-nav__menu').forEach((item) => item.addEventListener('click', toggleMenu))
	document.querySelectorAll('.nav__site li:not(.has-children)').forEach((item) => item.addEventListener('click', toggleMenu))

	// hide header on scroll down (nur oberhalb des Schwellwerts sinnvoll) ==================
	let didScroll = false
	let lastScrollTop = 0
	const delta = 20

	document.addEventListener('scroll', function () {
		didScroll = true
	})

	window.addEventListener(
		'resize',
		function () {
			const st = getScrollTop()
			updateHeaderTopState(st)
			if (st < scrollThresholdPx()) {
				header.classList.remove('nav-up')
				header.classList.add('nav-down')
			}
		},
		{ passive: true }
	)

	header.classList.add('nav-down')
	updateHeaderTopState(getScrollTop())

	setInterval(function () {
		if (didScroll) {
			if (!navMenu.classList.contains('is-active')) {
				hasScrolled()
			}
			didScroll = false
		}
	}, 250)

	function hasScrolled() {
		const st = getScrollTop()
		const threshold = scrollThresholdPx()

		updateHeaderTopState(st)

		// Im oberen Bereich (< 50vh): Header immer sichtbar, kein Wegschieben
		if (st < threshold) {
			header.classList.remove('nav-up')
			header.classList.add('nav-down')
			lastScrollTop = st
			return
		}

		if (Math.abs(lastScrollTop - st) <= delta) {
			return
		}

		// Ab Schwellwert: nach unten scrollen → Header verstecken
		if (st > lastScrollTop && st > threshold) {
			header.classList.remove('nav-down')
			header.classList.add('nav-up')
		} else {
			header.classList.remove('nav-up')
			header.classList.add('nav-down')
		}

		lastScrollTop = st
	}

	document.addEventListener('keydown', function (event) {
		if (event.key === 'Escape') {
			const body = document.querySelector('body')

			if (body.classList.contains('js-nav-open')) {
				body.classList.remove('js-nav-open')
				navMenu.classList.remove('is-active')
			}
		}
	})
}
